import React from 'react';
import {AllMessages} from "../../components";

const Messages = () => {
    return <AllMessages/>
};

export default Messages;